import { requiresRequestFlow, TDR } from 'tdr-common';
import { analytics, TABLE_CLICKED_FROM_CAROUSEL } from '../../helpers/analytics';
import { SearchFilters } from '../../routes/AvailabilityGuard';
import { AnnouncementResponse } from '../announcements/common';
import { TableCategoryCounts } from './categorizeTables';

export type CardTableStatus = 'available' | 'time_conflict' | 'date_conflict' | 'date_sold_out' | 'date_closed' | 'groupsize_conflict';

export type EmitTableClickedInput = {
	table: TDR.Table;
	restaurantId: string;
	searchFilters: SearchFilters;
	counts: TableCategoryCounts;
	totalResults: number;
	position: number;
	tableStatus: CardTableStatus;
	announcement?: AnnouncementResponse;
	hasScrolledToBottom?: boolean;
};

export function emitTableClicked({
	table,
	restaurantId,
	searchFilters,
	counts,
	totalResults,
	position,
	tableStatus,
	announcement,
	hasScrolledToBottom
}: EmitTableClickedInput) {
	analytics.track(TABLE_CLICKED_FROM_CAROUSEL, {
		position: position.toString(),
		hasAnnouncement: (!!announcement).toString(),
		tableStatus,
		tableId: table.id,
		tableName: table.name,
		maxGuests: table.maxGuests.toString(),
		minGuests: table.minGuests.toString(),
		// Renamed to match the other three booking-type analytics sites (BookNowButton, Policies,
		// TableDrawer), which all already emit `isLargeGroup`. This event was the odd one out.
		isLargeGroup: requiresRequestFlow(table).toString(),
		internalName: table.internalName || '',
		isPatio: (table.isPatio || false).toString(),
		restaurantId,
		availableTables: counts.available.toString(),
		dateConflictTables: counts.dateConflict.toString(),
		timeConflictTables: counts.timeConflict.toString(),
		dateSoldOutTables: counts.dateSoldOut.toString(),
		dateClosedTables: counts.dateClosed.toString(),
		totalResults: totalResults.toString(),
		groupSize: searchFilters.groupSize?.toString() || '',
		date: searchFilters.date || '',
		time: searchFilters.time || '',
		hasScrolledToBottom: (hasScrolledToBottom ?? false).toString()
	});
}
